"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _this = void 0,
    _arguments = arguments;

var _default = function _default(func, startIndex) {
  startIndex = startIndex == null ? func.length - 1 : +startIndex;
  return function () {
    var length = Math.max(_arguments.length - startIndex, 0);
    var rest = Array(length);
    var index = 0;

    for (; index < length; index++) {
      rest[index] = _arguments[index + startIndex];
    }

    switch (startIndex) {
      case 0:
        return func.call(_this, rest);

      case 1:
        return func.call(_this, _arguments[0], rest);

      case 2:
        return func.call(_this, _arguments[0], _arguments[1], rest);
    }

    var args = Array(startIndex + 1);

    for (index = 0; index < startIndex; index++) {
      args[index] = _arguments[index];
    }

    args[startIndex] = rest;
    return func.apply(_this, args);
  };
};

exports["default"] = _default;